<template>
  <div
    :id="`wrapper_${index}`"
    class="relative mt-20 max-w-screen-lg"
  >
    <h2 class="text-header3 md:text-desktop-header3">
      {{ slice.primary.title }}
    </h2>
    <h3 class="mt-10 text-header4 md:text-desktop-header4">
      {{ slice.primary.sub_title }}
    </h3>
    <PrismicRichText
      :field="slice.primary.content"
      class="mt-10 text-body-copy md:text-desktop-body-copy"
    />

    <UIButton
      v-for="(button, index) in slice.primary.actions"
      :key="index"
      :type="button.type"
      :label="button.label"
      :link="prismic.asLink(button.link)"
      class="mt-5"
    />
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

const prismic = usePrismic();

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
const props = defineProps(
  getSliceComponentProps<Content.IntroLinkSlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);
</script>
